import { render, staticRenderFns } from "./inst.vue?vue&type=template&id=4deb6fcc"
import script from "./inst.vue?vue&type=script&lang=js"
export * from "./inst.vue?vue&type=script&lang=js"
import style0 from "./inst.vue?vue&type=style&index=0&id=4deb6fcc&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports